import ActivityPlanActions from "../../prat_actions/activityPlan/activityPlanActions";

const ActivityPlanReducer = (
  state = { isActivityPlanLoading: false,activityPlanHasError:false,activityPlan:[] },
  action
) => {
  switch (action.type) {
    case ActivityPlanActions.ACTIVITY_PLAN_REQUEST:
      return {
        ...state,
        isActivityPlanLoading: true,
        activityPlan:[],
        activityPlanHasError:false
      };
    case ActivityPlanActions.ACTIVITY_PLAN_SUCCESSFUL:
      return {
        ...state,
        isActivityPlanLoading: false,
        activityPlan: action.data.data,
        activityPlanHasError:false
      };
    case ActivityPlanActions.ACTIVITY_PLAN_FAILED:
      return {
        ...state,
        errorMessage: {},
        isActivityPlanLoading: false,
        activityPlan:[],
        activityPlanHasError:true
      };
    default:
      return {
        ...state
      };
    //   break;
  }
};

export default ActivityPlanReducer;
